export * from './actividades.service';
import { ActividadesService } from './actividades.service';
export * from './adjuntos.service';
import { AdjuntosService } from './adjuntos.service';
export * from './check.service';
import { CheckService } from './check.service';
export * from './empresas.service';
import { EmpresasService } from './empresas.service';
export * from './eventos.service';
import { EventosService } from './eventos.service';
export * from './fotosActividades.service';
import { FotosActividadesService } from './fotosActividades.service';
export * from './fotosEventos.service';
import { FotosEventosService } from './fotosEventos.service';
export * from './kogui.service';
import { KoguiService } from './kogui.service';
export * from './koguiActividades.service';
import { KoguiActividadesService } from './koguiActividades.service';
export * from './koguiEmpresas.service';
import { KoguiEmpresasService } from './koguiEmpresas.service';
export * from './koguiEventos.service';
import { KoguiEventosService } from './koguiEventos.service';
export * from './koguiFavorite.service';
import { KoguiFavoriteService } from './koguiFavorite.service';
export * from './koguiOpiniones.service';
import { KoguiOpinionesService } from './koguiOpiniones.service';
export * from './koguiProgramacionActividad.service';
import { KoguiProgramacionActividadService } from './koguiProgramacionActividad.service';
export * from './koguiReservas.service';
import { KoguiReservasService } from './koguiReservas.service';
export * from './programacionActividad.service';
import { ProgramacionActividadService } from './programacionActividad.service';
export * from './reservas.service';
import { ReservasService } from './reservas.service';
export const APIS = [ActividadesService, AdjuntosService, CheckService, EmpresasService, EventosService, FotosActividadesService, FotosEventosService, KoguiService, KoguiActividadesService, KoguiEmpresasService, KoguiEventosService, KoguiFavoriteService, KoguiOpinionesService, KoguiProgramacionActividadService, KoguiReservasService, ProgramacionActividadService, ReservasService];
